export default __webpack_public_path__ + "static/media/weights.c0be47bd.png";